var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.4219C9.32812 17.8906 8.625 17.8906 8.20312 17.4219L5.57812 14.7969C5.10938 14.375 5.10938 13.6719 5.57812 13.2031C6 12.7812 6.70312 12.7812 7.125 13.2031L9 15.0781L13.4531 10.5781C13.875 10.1562 14.5781 10.1562 15 10.5781C15.4688 11.0469 15.4688 11.75 15 12.1719L9.75 17.4219ZM20.7188 6.6875C20.9062 7.0625 21 7.48438 21 7.90625V18.5C21 20.1875 19.6406 21.5 18 21.5H3C1.3125 21.5 0 20.1875 0 18.5V7.90625C0 7.48438 0.046875 7.0625 0.234375 6.6875L2.20312 2.32812C2.67188 1.20312 3.75 0.5 4.92188 0.5H16.0312C17.2031 0.5 18.2812 1.20312 18.75 2.32812L20.7188 6.6875ZM11.625 6.5H18.1875L16.7344 3.21875C16.5938 2.9375 16.3125 2.75 16.0312 2.75H11.625V6.5ZM2.25 18.5C2.25 18.9219 2.57812 19.25 3 19.25H18C18.375 19.25 18.75 18.9219 18.75 18.5V8.75H2.25V18.5ZM9.375 2.75H4.92188C4.64062 2.75 4.35938 2.9375 4.21875 3.21875L2.76562 6.5H9.375V2.75Z",
    fill: "#7468DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMember);
export default __webpack_public_path__ + "static/media/newMember.4f0ce14e66575cc48e0563f40af01fce.svg";
export { ForwardRef as ReactComponent };